import { BorrowerTypeLabel } from 'constants/loanApplication';

export const getPersonLabel = ({ borrowerType, orderNumber }) => {
  return BorrowerTypeLabel[borrowerType] || `Title Holder ${orderNumber}`;
};
